import { getEnabledElement } from "component/toolManager/enabledElements.js";
import CustomEvent from "core/customEvent/index";

class WwwcTool {
  constructor() {
    this.orientation = 0;
  }

  onMouseDrag = evt => {
    const eventData = evt.detail;

    let viewportObject = eventData.viewportObject;

    const minPixelValue = eventData.image.minMax[0];
    const maxPixelValue = eventData.image.minMax[1];
    const slope = eventData.image.rescaleSlope;
    const intercept = eventData.image.rescaleIntercept;

    const maxVOI = maxPixelValue * slope + intercept;
    const minVOI = minPixelValue * slope + intercept;

    const imageDynamicRange = maxVOI - minVOI;
    const multiplier = imageDynamicRange / 1024;

    const deltaX = eventData.deltaPoints.page.x * multiplier;
    const deltaY = eventData.deltaPoints.page.y * multiplier;

    //if (orientation === 0) {
    if (this.orientation === 0) {
      eventData.element.viewport.voi.windowWidth += deltaX;
      eventData.element.viewport.voi.windowCenter -= deltaY;
    } else {
      eventData.element.viewport.voi.windowWidth += deltaY;
      eventData.element.viewport.voi.windowCenter += deltaX;
    }

    if (eventData.element.viewport.voi.windowWidth < 1) {
      eventData.element.viewport.voi.windowWidth = 1;
    }

    if (deltaX === 0 && deltaY === 0) {
      viewportObject.setViewport(eventData.element.viewport, "");
    } else {
      viewportObject.setViewport(eventData.element.viewport, "WwwcTool");
    }

    // wwwc 변경에 따른 이벤트 발생
    var elementStub = getEnabledElement(eventData.element.element);
    CustomEvent.triggerEvent(
      eventData.element.element,
      CustomEvent.EVENTS.WWWC_CHANGED,
      elementStub
    );
  };
}

export default WwwcTool;
